var _excluded = ["checked", "disabled", "error", "fieldSize", "id", "name", "label", "required", "style", "tabIndex", "value"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import FieldLabel from "../FieldLabel/FieldLabel.js";
/* TYPES */
/* VISIBLE RADIO BUTTON */
var StyledRadioButton = styled.div.withConfig({
  componentId: "CL__sc-1yptduc-0"
})(["border:var(--radio-border-size) solid var(--border-color);border-radius:var(--radio-size);display:block;height:var(--radio-size);left:0;position:absolute;top:var(--radio-top);transition:border-color var(--hover-transition);width:var(--radio-size);&:before{background:var(--highlight-color);border-radius:100px;content:'';display:block;height:var(--radio-bullet-size);width:var(--radio-bullet-size);left:50%;opacity:0;position:absolute;top:50%;transform:translate(-50%,-50%);transition:opacity var(--hover-transition);}"]);

/* INVISIBLE RADIO BUTTON */
var RadioInput = styled.input.withConfig({
  componentId: "CL__sc-1yptduc-1"
})(["clip-path:inset(50%);clip:rect(0 0 0 0);height:1px;overflow:hidden;margin:0;position:absolute;white-space:nowrap;width:1px;"]);

/* LABEL */
var StyledFieldLabel = styled(FieldLabel).withConfig({
  componentId: "CL__sc-1yptduc-2"
})(["cursor:pointer;font-weight:var(--body-text-normal-font-weight);padding:0 var(--radio-margin) 0 calc(var(--radio-size) + var(--radio-margin));position:relative;"]);

/* MAIN CONTAINER - controls interaction styling and sizing */
var RadioContainer = styled.div.withConfig({
  componentId: "CL__sc-1yptduc-3"
})(["align-items:center;cursor:", ";display:block;position:relative;&:hover ", ":not(:disabled) + ", "{border-color:var(--highlight-color);}&:active ", ":not(:disabled) + ", "{border-color:var(--link-color-hover);}& ", ":not(:disabled):focus-visible{box-shadow:0 0 5px var(--highlight-color);border-color:var(--highlight-color);}& ", ":disabled + ", "{border-color:var(--border-color-dim);}& ", ":disabled + ", ":before{background-color:var(--border-color-dim);}& ", ":not(:disabled):checked + ", "{border-color:var(--highlight-color);}& ", ":checked + ", ":before{opacity:1;}& ", ":not(:disabled):focus-visible + ", "{box-shadow:0 0 5px var(--highlight-color);border-color:var(--highlight-color);}", " ", " ", " ", ""], _ref => {
  var {
    disabled
  } = _ref;
  return disabled ? 'default' : 'pointer';
}, RadioInput, StyledRadioButton, RadioInput, StyledRadioButton, RadioInput, RadioInput, StyledRadioButton, RadioInput, StyledRadioButton, RadioInput, StyledRadioButton, RadioInput, StyledRadioButton, RadioInput, StyledRadioButton, _ref2 => {
  var {
    error
  } = _ref2;
  return error && "\n    & ".concat(StyledRadioButton, " {\n      border-color: var(--error-color);\n    }\n\n    &:hover ").concat(RadioInput, ":not(:disabled) + ").concat(StyledRadioButton, " {\n      border-color: var(--error-color);\n    }\n\n    & ").concat(RadioInput, ":not(:disabled):checked + ").concat(StyledRadioButton, " {\n      border-color: var(--error-color);\n    }\n\n    & ").concat(RadioInput, ":checked + ").concat(StyledRadioButton, ":before {\n      background-color: var(--error-color);\n    }\n\n    & ").concat(RadioInput, ":not(:disabled):focus-visible + ").concat(StyledRadioButton, " {\n      box-shadow: 0 0 5px var(--error-color);\n      border-color: var(--error-color);\n    }\n    ");
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return fieldSize === 'large' ? "\n    --radio-size: var(--spacing-4);\n    --radio-top: 0;\n    --radio-bullet-size: var(--spacing-2);\n    --radio-margin: var(--spacing-2);\n    --radio-border-size: 2px;\n    " : "";
}, _ref4 => {
  var {
    fieldSize
  } = _ref4;
  return fieldSize === 'medium' ? "\n    --radio-size: var(--spacing-3);\n    --radio-top: 3px;\n    --radio-bullet-size: calc(var(--spacing-1) + 2px);\n    --radio-margin: calc(var(--spacing-1) + 2px);\n    --radio-border-size: 2px;\n    " : "";
}, _ref5 => {
  var {
    fieldSize
  } = _ref5;
  return fieldSize === 'small' ? "\n    --radio-size: var(--spacing-2);\n    --radio-top: 3px;\n    --radio-bullet-size: var(--spacing-1);\n    --radio-margin: var(--spacing-1);\n    --radio-border-size: 1px;\n    " : "";
});
var Radio = /*#__PURE__*/React.forwardRef((_ref6, ref) => {
  var {
      checked = false,
      disabled = false,
      error = false,
      fieldSize = 'medium',
      id = '',
      name = '',
      label,
      required = false,
      style,
      tabIndex = 0,
      value
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded);
  return /*#__PURE__*/React.createElement(RadioContainer, {
    disabled: disabled,
    error: error,
    fieldSize: fieldSize,
    style: style
  }, /*#__PURE__*/React.createElement(RadioInput, _extends({
    checked: checked,
    disabled: disabled,
    id: id,
    name: name,
    ref: ref,
    required: required,
    tabIndex: tabIndex,
    type: "radio",
    value: value
  }, props)), /*#__PURE__*/React.createElement(StyledRadioButton, null), /*#__PURE__*/React.createElement(StyledFieldLabel, {
    fieldSize: fieldSize,
    htmlFor: id,
    required: required
  }, label));
});
export default Radio;